/**
 * Convert Persian (۰–۹) and Arabic-Indic (٠–٩) digits to ASCII 0–9.
 * Leaves other characters unchanged.
 */
export function toAsciiDigits(input) {
    return input
        .replace(/[\u06F0-\u06F9]/g, (ch) => String.fromCharCode(0x30 + (ch.charCodeAt(0) - 0x06f0)))
        .replace(/[\u0660-\u0669]/g, (ch) => String.fromCharCode(0x30 + (ch.charCodeAt(0) - 0x0660)));
}
/** Normalize digit scripts then keep only ASCII digits (for TOTP). */
export function normalizeTotpCode(input) {
    return toAsciiDigits(input).replace(/\D/g, "");
}
//# sourceMappingURL=digits.js.map